module.exports = __webpack_public_path__ + "img/slider_3.fef42012.png";